module.exports = __webpack_public_path__ + "static/media/jntua_logo.9699ca33.png";